import { Component } from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import { EngagementService } from '../engagement.service';
import { SitesService } from 'src/app/mobile/shared/sites.service';

@Component({
  selector: 'app-engagement-wrapper-for-crm',
  template: '<app-engagement class="ion-page" *ngIf=contextLoaded></app-engagement>',
})
export class EngagementWrapperForCRMComponent {
  contextLoaded: boolean;
  constructor(public engagementService: EngagementService, route: ActivatedRoute, private sitesService: SitesService) {
    try {
      engagementService.channelType = this.sitesService.sitesV2Map.get(+route.snapshot.params.siteId).typeName;
      engagementService.strategy.isCRMMode = route.snapshot.data.isCRMMode;
      engagementService.strategy.externalUser = route.snapshot.params.userExternalId;
    } catch (e) {
      // Do nothing
      console.log(e);
    }
    route.paramMap.subscribe(({ params }: any) => {
      const { userExternalId, siteId } = params;
      if (userExternalId && siteId) {
        this.contextLoaded = true;
      }
    });
  }
}
